export default "__VITE_ASSET__CL33__RF__"